module.exports = __webpack_public_path__ + "img/controlId.2ef603a8.jpg";